import { render, staticRenderFns } from "./PropertyText.vue?vue&type=template&id=ca97eefa&"
import script from "./PropertyText.vue?vue&type=script&lang=js&"
export * from "./PropertyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports